
import React from 'react';
import { Field } from 'redux-form';
import FormLabel from '@material-ui/core/FormLabel'
import RadioGroup from '@material-ui/core/RadioGroup';


const renderRadioGroup = ({input, label, required = false,...rest,style, radioGroupStyle, labelStyle, meta: { touched, error }}) => (
    <div style={radioGroupStyle}>
        <FormLabel component="label" style={labelStyle}>{label}{required && <span>*</span>}{touched && <span style={{color: '#f44336'}}>{error}</span>} </FormLabel>
        <RadioGroup
            {...input}
            {...rest}
            style={style}
            value={input.value}
            onChange={(event,value) => input.onChange(value)}
            required={required}
        />
    </div>
)
export default (obj) => {
    return <Field component={renderRadioGroup} {...obj} />
}


// WEBPACK FOOTER //
// ./src/uis/form/radio.js